var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMonitorEngineContext } from "@nibfe/mcp-monitor-sdk";
import { useRequest, API_PATH } from "./useRequest";
import { useState } from "@max/max";
export function useDraw(options) {
    const ctx = useMonitorEngineContext();
    const [drawInfo, setDrawInfo] = useState(null);
    const [drawResult, setDrawResult] = useState(null);
    const { requestStatus: queryStatus, request: queryRequest } = useRequest(API_PATH.DRAW_QUERY);
    const { requestStatus: operatorStatus, request: operatorRequest } = useRequest(API_PATH.DRAW_OPERATOR);
    function loadDrawInfo() {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield queryRequest({
                    activityId: options.activityId,
                    taskId: options.taskId
                });
                if (!res) {
                    throw new Error('获取抽奖信息失败');
                }
                setDrawInfo(res);
                (_b = (_a = ctx._raptorReport).monitorReportBizSuccess) === null || _b === void 0 ? void 0 : _b.call(_a, {
                    apiPath: API_PATH.DRAW_QUERY
                });
            }
            catch (error) {
                (_d = (_c = ctx._raptorReport).monitorReportBizFailed) === null || _d === void 0 ? void 0 : _d.call(_c, {
                    apiPath: API_PATH.DRAW_QUERY
                });
                ctx._raptorReport.monitorReportLog(error.message, error, {
                    category: 'ajaxError',
                    level: 'error'
                });
            }
        });
    }
    function doDraw() {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield operatorRequest({
                    activityId: options.activityId,
                    taskId: options.taskId
                });
                if (!res) {
                    throw new Error('抽奖失败');
                }
                setDrawResult(res);
                (_b = (_a = ctx._raptorReport).monitorReportBizSuccess) === null || _b === void 0 ? void 0 : _b.call(_a, {
                    apiPath: API_PATH.DRAW_OPERATOR
                });
                loadDrawInfo(); // 刷新可抽次数
                return res;
            }
            catch (error) {
                (_d = (_c = ctx._raptorReport).monitorReportBizFailed) === null || _d === void 0 ? void 0 : _d.call(_c, {
                    apiPath: API_PATH.DRAW_OPERATOR
                });
                ctx._raptorReport.monitorReportLog(error.message, error, {
                    category: 'ajaxError',
                    level: 'error'
                });
                return null;
            }
        });
    }
    return {
        loadDrawInfo,
        doDraw,
        queryStatus,
        operatorStatus,
        drawInfo,
        drawResult
    };
}
